export default () => ({
    state: Alpine.$persist('unknown').as('cookieConsent'),
    init() {
        this.animate()
        this.dispatch()
    },

    dialogue: {
        ['x-show']() {
            return this.state === 'unknown'
        },
    },

    accept: {
        ['@click']() {
            this.state = 'accepted'
            this.dispatch()
        },
    },

    animate() {
        gsap.from(this.$refs.overlay, {
            xPercent: 120,
            duration: 0.4,
            delay: this.$store.avalanche.delay.enter + 0.6,
            ease: 'circ.out',
        })
    },

    dispatch() {
        document.dispatchEvent(
            new CustomEvent('cookieConsent', {
                detail: this.state,
            }),
        )
    },
})
